import { Site } from '../home.page.jsx';
import './legal.css';

export default function AgbPage() {
  return (
    <div className="legal-content">
      <h1>Allgemeine Geschäftsbedingungen (AGB) der MCloud</h1>
      <p>Stand: 24. August 2025</p>
      <ol>
        <li>
          <h2><span className="legal-num">1.</span> Geltungsbereich</h2>
          <p>
            Diese AGB regeln die Nutzung der webbasierten Plattform „MCloud“ bereitgestellt durch Leonard Nürnberg, Heinrich-Narjes Str. 34, 67346 Speyer (nachfolgend „Anbieter“) und den registrierten Nutzer (nachfolgend „Kunde“). 
            Abweichende Bedingungen des Kunden werden nur Vertragsbestandteil, wenn der Anbieter ihnen ausdrücklich und schriftlich zustimmt.
          </p>
        </li>
        <li>
          <h2><span className="legal-num">2.</span> Inkrafttreten</h2>
          <ol>
            <li>
              Mit der Registrierung und der Bestätigung dieser AGB erklären Sie sich mit deren Gültigkeit einverstanden. Die AGB treten mit Abschluss des Registrierungsprozesses in Kraft.
            </li>
          </ol>

          <ol>
            <li>
              <h3><span className="legal-num">2.1</span> Registrierung und GitHub-Authentifizierung</h3>
              <p>
                Die Registrierung erfolgt durch Verknüpfung des persönlichen GitHub-Kontos des Benutzers.
              </p>
              <p>
                Durch die Verknüpfung erstellt der Nutzer ein Nutzerkonto auf der Platform des Anbieters.
              </p>

              <p>
                Im Rahmen der Verknüpfung wird der bei GitHub hinterlegte Name, E-Mail Adresse und URL zum Avatar vom Anbieter abgerufen und im Benutzerkonto hinterlegt. Weitere Informationen können unserer Datenschutzrichtlinie entnommen werden.
              </p>
              <p>
                Diese Anwendung steht in keiner Verbindung zu, wird nicht unterstützt von und ist in keiner Weise mit GitHub, Inc. oder deren Tochtergesellschaften verbunden. Alle Logos, Marken und sonstigen geistigen Eigentumsrechte von GitHub sind das Eigentum von GitHub, Inc.
              </p>
            </li>
            <li>
              <h3><span className="legal-num">2.2</span> Vertragssprache </h3>
              <p>
                Die Vertragssprache ist Deutsch. 
              </p>
              <p>
                Eine Speicherung des vollständigen Vertragstextes durch den Anbieter erfolgt nicht. Diese AGB können vom Kunden heruntergeladen und lokal gespeichert werden.
              </p>
            </li>
          </ol>
        </li>

        <li>
          <h2><span className="legal-num">3.</span> Zustimmung</h2>
          <ol>
            <li>
              Durch die Registrierung bestätigen Sie, dass Sie die AGB gelesen und akzeptiert haben. Ohne Zustimmung zu diesen Bedingungen ist eine Registrierung nicht möglich.
            </li>
          </ol>
        </li>

        <li>
          <h2><span className="legal-num">3.</span> Leistungen</h2>
          <ol>
            <li>
              <p>
                Der Anbieter stellt eine Browser-plattform bereit, auf der der Kunde öffentlich verfügbare Open-Source-KI-Modelle auf anonymisierte DICOM-Daten ausführt.
              </p>
            </li>
            <li>
              <p>
                Der lokale DICOM-Store verbleibt im Browser des Kunden; Daten werden nur bei konkreter Verarbeitung zum Dienst übertragen.
              </p>
            </li>
            <li>
              <p>
                Verarbeitung und Speicherung erfolgen ausschließlich in AWS-Rechenzentren in Frankfurt, Deutschland.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <h2><span className="legal-num">4.</span> Credits und Zahlung</h2>
          <ol>
            <li>
              <p>
                Credits sind virtuelle Guthaben­einheiten zur Ausführung von Tasks. Ein Credit kostet 0,25 €.
              </p>
            </li>
            <li>
              <p>
                Mindestabnahme je Transaktion: 20 Credits (5,00 €). Maximal buchbar pro Transaktion und insgesamt auf dem Konto: 100 Credits (25,00 €).
              </p>
            </li>
            <li>
              <p>
                Credits werden bei Aufgabe eines Tasks reserviert und bei Start des Tasks verbraucht. Nicht verbrauchte Credits verfallen bei Vertragsende.
              </p>
            </li>
            <li>
              <p>
                Credits haben keinen Geldwert außerhalb des Dienstes und können nicht ausgezahlt oder übertragen werden.
              </p>
            </li>
            <li>
              <p>
                Zahlungen werden über Paddle abgewickelt. Es gelten die Datenschutzbestimmungen und AGB von Paddle. Der Kunde willigt ein, dass zur Zahlungsabwicklung erforderliche Daten an Paddle übermittelt werden. Für Zahlungsprobleme, die durch Paddle verursacht werden, übernimmt der Anbieter keine Haftung.
              </p>
            </li>
            <li>
              <p>
                Alle Zahlungen sind unwiderruflich und grundsätzlich von Erstattungen ausgeschlossen.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <h2><span className="legal-num">5.</span> Datenanonymisierung und Upload</h2>
          <ol>
            <li>
              <p>
                Der Kunde ist verpflichtet, alle DICOM-Daten vor Upload vollständig zu anonymisieren.
              </p>
            </li>
            <li>
              <p>
                Das Hochladen nicht-anonymisierter Daten, insbesondere von Patientendaten mit Identifikationsmerkmalen, ist unzulässig. Der Anbieter kann unzulässige Daten ablehnen oder löschen.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <h2><span className="legal-num">6.</span> Datenverarbeitung, Speicherfristen</h2>
          <ol>
            <li>
              <p>
                Nach Upload werden die Daten in einem S3-Bucket in Frankfurt nur bis zum Abschluss der Verarbeitung gespeichert; sie werden unmittelbar danach gelöscht.
              </p>
            </li>
            <li>
              <p>
                Die generierten Ergebnisse stehen für 14 Tage zum Download bereit; danach werden sie unwiederbringlich gelöscht.
              </p>
            </li>
            <li>
              <p>
                Zur internen Abrechnung speichert der Anbieter einzig die SeriesInstanceUID; Bilddaten oder sonstige personenbezogene Daten werden nicht dauerhaft aufbewahrt.
              </p>
            </li>
            <li>
              <p>
                Alle Verarbeitung und Speicherung erfolgen DS-GVO-konform in Frankfurt, Deutschland.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <h2><span className="legal-num">7.</span> Verfügbarkeit und Wartung</h2>
          <ol>
            <li>
              <p>
                Der Dienst befindet sich in der Beta-Phase; es besteht keine Garantie für Verfügbarkeit oder Betriebszeiten.
              </p>
            </li>
            <li>
              <p>
                Geplante Wartungen werden im Dienst rechtzeitig angekündigt. Ungeplante Wartungen (z. B. Hot Fixes) können jederzeit ohne Vorankündigung erfolgen.
              </p>
            </li>
            <li>
              <p>
                Der Anbieter darf den Dienst jederzeit ganz oder teilweise aussetzen oder beenden; ungenutzte Credits verfallen in diesem Fall ersatzlos.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <h2><span className="legal-num">8.</span> Gewährleistung</h2>
          <ol>
            <li>
              <p>
                Es gilt das gesetzliche Mängelgewährleistungsrecht.
              </p>
            </li>
            <li>
              <p>
                Der Kunde muss Mängel unverzüglich melden; unterlässt er dies, verliert er seine Gewährleistungsrechte, soweit der Anbieter dadurch nicht in erheblichem Maße benachteiligt wird.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <h2><span className="legal-num">9.</span> Haftung und Freistellung</h2>
          <ol>
            <li>
              <p>
                Der Anbieter haftet uneingeschränkt für Vorsatz und grobe Fahrlässigkeit sowie für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit.
              </p>
            </li>
            <li>
              <p>
                Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten (Kardinalpflichten) ist die Haftung auf den typischerweise vorhersehbaren Schaden begrenzt.
              </p>
            </li>
            <li>
              <p>
                Die Gesamthaftung des Anbieters ist der Höhe nach auf die im Jahr vor dem schädigenden Ereignis vom Kunden erworbenen Credits begrenzt.
              </p>
            </li>
            <li>
              <p>
                Eine Haftung für entgangenen Gewinn oder sonstige Vermögensschäden des Kunden ist ausgeschlossen, soweit gesetzlich zulässig.
              </p>
            </li>
            <li>
              <p>
                Der Kunde stellt den Anbieter von sämtlichen Ansprüchen Dritter frei, die aufgrund seiner Nutzung des Dienstes oder eines Verstoßes gegen diese AGB geltend gemacht werden, einschließlich Kosten der Rechtsverteidigung.
              </p>
            </li>
            <li>
              <p>
                Der Anbieter kann die Korrektheit der Modelle nicht varifizieren oder garantieren. Der Kunde ist für die Auswahl und Anwendung der Modelle selbst verantwortlich.
              </p>
            </li>
            <li>
              <p>
                Erzeugnisse der KI Modelle sind nicht für medizinische Zwecke, Diagnosen oder Behandlungen geeignet. 
              </p>
            </li>
          </ol>
        </li>
        <li>
          <h2><span className="legal-num">10.</span> Höhere Gewalt</h2>
          <p>
            Der Anbieter haftet nicht für Verzögerungen oder Leistungsausfälle, die durch unvorhersehbare, von ihm nicht zu vertretende Ereignisse außerhalb seines Einflussbereichs entstehen (z. B. Naturkatastrophen, Krieg, Streiks, Netzwerkausfälle, behördliche Maßnahmen).
          </p>
        </li>
        <li>
          <h2><span className="legal-num">11.</span> Änderung der AGB</h2>
          <ol>
            <li>
              <p>
                Der Anbieter ist berechtigt, diese AGB aus sachlich gerechtfertigten Gründen (z. B. Änderungen in der Rechtsprechung, Gesetzeslage, Marktgegebenheiten oder Unternehmensstrategie) mit einer Frist von mindestens zwei Wochen ändern.
              </p>
            </li>
            <li>
              <p>
                Bestandskunden werden über wesentliche Änderungen im Dienst benachrichtigt. Sofern der Kunde nicht innerhalb der Frist widerspricht, gelten die Änderungen als angenommen. Widerspricht der Kunde, kann der Anbieter das Vertragsverhältnis mit angemessener Frist kündigen.
              </p>
            </li>
          </ol>
        </li>
        {/* <li>
          <h2><span className="legal-num">12.</span> Online-Streitbeilegung / Verbraucherstreitschlichtung</h2>
          <p>
            Die EU-Kommission stellt unter <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a> eine Plattform zur Online-Streitbeilegung bereit. Der Anbieter ist weder bereit noch verpflichtet, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </li> */}
        <li>
          <h2><span className="legal-num">12.</span> Schlussbestimmungen</h2>
          <ol>
            <li>
              <p>
                Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts.
              </p>
            </li>
            <li>
              <p>
                Ist der Kunde Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen, ist ausschließlicher Gerichtsstand Berlin.
              </p>
            </li>
          </ol>
        </li>
      </ol>
    </div>
  );
}

AgbPage.layout = page => <Site>{ page }</Site>
